import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createNotice({ commit }, notice) {
    return new Promise((resolve, reject) => {
      axios
        .post('notices', { notice })
        .then(response => {
          commit('ADD_NOTICE', response.data.id)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchNotices(context) {
    const query = QuerySerialize(context.state.query)
    const skip = context.state.skip
    const limit = context.state.limit
    return new Promise((resolve, reject) => {
      axios
        .get(`notices/?skip=${skip}&limit=${limit}&${query}`)
        .then(response => {
          context.commit('SET_NOTICES', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countNotices(context) {
    const query = QuerySerialize(context.state.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`notices/count/?${query}`)
        .then(response => {
          context.commit('SET_NOTICES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editNotice({ commit }, notice) {
    return new Promise((resolve, reject) => {
      axios
        .put(`notices/${notice.id}`, notice.data)
        .then(response => {
          // Convert Date String to Date Object
          const notice = response.data

          commit('UPDATE_NOTICE', notice)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeNotice({ commit }, noticeId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`notices/${noticeId}`)
        .then(response => {
          commit('REMOVE_NOTICE', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
